import { QRCodeCanvas } from "qrcode.react";
import { useRef } from "react";
import { Download, Printer } from "lucide-react";

export default function QRPage() {
  const url = `${window.location.origin}/quote`;
  const canvasWrapRef = useRef(null);

  const download = () => {
    const canvas = canvasWrapRef.current?.querySelector("canvas");
    if (!canvas) return;
    const link = document.createElement("a");
    link.download = "colourmatch-quote-qr.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  const print = () => window.print();

  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-12 lg:py-20" data-testid="qr-page">
      <div className="overline mb-3">Scan · Request · Done</div>
      <h1 className="font-serif text-4xl lg:text-5xl tracking-tight mb-3">QR code for quick quotes</h1>
      <p className="text-brand-muted mb-10 max-w-2xl">
        Print this poster or share the QR digitally. Anyone who scans it lands directly on the quote form —
        ideal for site signs, flyers, vehicle wraps and business cards.
      </p>

      <div className="grid md:grid-cols-5 gap-6 print:gap-0">
        <div className="md:col-span-3 bg-white border border-brand-linen p-10 lg:p-14 text-center" ref={canvasWrapRef} data-testid="qr-poster">
          <div className="overline mb-6">ColourMatch</div>
          <h2 className="font-serif text-3xl mb-2">Scan to start your quote</h2>
          <p className="text-sm text-brand-muted mb-8">No-obligation · 2 minute estimate</p>
          <div className="inline-block bg-white p-4 border border-brand-linen">
            <QRCodeCanvas value={url} size={240} bgColor="#FFFFFF" fgColor="#2C3E35" level="H" />
          </div>
          <p className="mt-6 text-xs text-brand-muted break-all">{url}</p>
        </div>

        <div className="md:col-span-2 space-y-3 print:hidden">
          <div className="bg-brand-sage text-white p-6">
            <div className="overline text-white/70 mb-2">Quote form URL</div>
            <p className="text-sm break-all font-mono">{url}</p>
          </div>
          <button onClick={download} data-testid="qr-download-btn"
            className="w-full flex items-center justify-center gap-2 bg-white border border-brand-linen px-6 py-3 text-sm hover:bg-brand-linen/40">
            <Download size={16} /> Download PNG
          </button>
          <button onClick={print} data-testid="qr-print-btn"
            className="w-full flex items-center justify-center gap-2 bg-white border border-brand-linen px-6 py-3 text-sm hover:bg-brand-linen/40">
            <Printer size={16} /> Print poster
          </button>
        </div>
      </div>
    </div>
  );
}
